import { render, staticRenderFns } from "./NewMatrixSyllabus.vue?vue&type=template&id=85bf32ee&"
import script from "./NewMatrixSyllabus.vue?vue&type=script&lang=js&"
export * from "./NewMatrixSyllabus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports